export const SET_STANDARD_SNACKBAR_STATE = 'SET_SNACKBAR_STATE';
export const RESET_STANDARD_SNACKBAR = 'RESET_STANDARD_SNACKBAR';

export const setStandardSnackbarState = (message, showSnackbar, hideAfter = 4000, classNames = 'bl-snackbar') => {
    return {
        type: SET_STANDARD_SNACKBAR_STATE,
        message,
        showSnackbar,
        hideAfter,
        classNames
    }
};

export const resetStandardSnackbar = () => {
    return {
        type: RESET_STANDARD_SNACKBAR
    }
};